export default __webpack_public_path__ + "static/media/img-slider-urban-transit-2.c3f4527d.png";